<template>
  <section class="row">
    <div class="col-sm-12">
      <slot/>
      <a
        v-for="post in posts"
        :key="post.id"
        :href="post.URL"
        :title="post.title">
        <div class="media">
          <div class="media-body">
            <h4
              class="media-heading"
              v-html="post.title"/>
            <div><strong>{{ post.dateForHumans }}</strong></div>
            <div
              v-html="post.excerpt"/>
          </div>
          <div
            v-if="post.featured_image"
            class="media-right">
            <img
              :src="post.featured_image + '?w=150'"
              :alt="post.title"
              class="media-object">
          </div>
        </div>
      </a>
    </div>
  </section>
</template>

<style scoped>
a {
  text-decoration: none;
  color: black;
}
.media {
  margin-bottom: 10px;
}
</style>

<script>
import axios from 'axios'
import { jrNotifyEx } from '../bootstrap'

export default {
  props: {
    count: {
      type: Number,
      default: 4
    }
  },

  data () {
    return {
      posts: []
    }
  },

  async created () {
    try {
      const cnt = this.count || 4
      const response = await axios.get("/blog/posts/" + cnt)
      this.posts = response.data.data
    } catch (e) {
      jrNotifyEx(e)
    }
  }
}
</script>
